export default __webpack_public_path__ + "static/media/1000.b4d66899.png";